import Link from '@components/Link';
import {resolveImagePath} from '@utils/imageUtils';
import type {ReactElement} from 'react';
import I18n from '@components/I18n';

export default function SuccessScreen(): ReactElement {
    return (
        <>
            <div className="custom-form__title">
                <I18n code="ClubForm_subscribe_successfulPayment" />
            </div>
            <div className="custom-form__subtitle">
                <I18n code="Questions" />{' '}
                <Link className="link-green-sizeless" to="mailto:letters@paperpaper.ru">
                    letters@paperpaper.ru
                </Link>
            </div>
            <img
                className="custom-form__success-img"
                src={resolveImagePath('custom_form_success.svg')}
                alt="Success"
            />
        </>
    );
}
